export default __webpack_public_path__ + "static/media/blurBg.f5f81beb.png";